import React, { Component } from 'react';
import NumericLabel from 'react-pretty-numbers';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translate } from 'react-polyglot';


import Link from '../Link';
import SvgIcon from '../SvgIcon';

import './Stat.scss';

class Stat extends Component {
  static defaultProps = {
    iconVariant: 'default',
    size: 'm'
  }

  render() {
    const baseClassName = 'pb-stat';

    const {
      icon,
      value,
      label,
      size,
      align,
      iconVariant,
      parentClassName,
      section,
      t,
      isRtl,
      shortFormatMinValue,
      shortFormatPrecision,
      justification
    } = this.props;

    let iconEl;
    if (icon) {
      iconEl = <SvgIcon parentClassName={`${baseClassName}__icon`} name={icon} title={section ? t(`SvgTitle.${section}-${icon}`) : t(`SvgTitle.${icon}`)} size={size} variant={iconVariant} isRtl={isRtl}/>
    }

    let stateEl;
    var option = {
          'commafy': false,
          'shortFormat':true,
          'shortFormatMinValue': shortFormatMinValue ? shortFormatMinValue :10000,
          'shortFormatPrecision': shortFormatPrecision ? shortFormatPrecision : null,
          'cssClass':[`${baseClassName}__rpn`],
          'justification': justification ? justification: null
        };
    if (value || value === 0) {
      stateEl = <span className={`${baseClassName}__value`}>
                  <NumericLabel params={option}>{value}</NumericLabel>
                </span>
    }

    let labelEl;
    if (label) {
      labelEl = <span className={`${baseClassName}__label`}>{label}</span>
    }

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--align-${align}`]: align,
      [`${baseClassName}--${size}`]: size,
      [`${baseClassName}--icon-${iconVariant}`]: iconVariant,
      [parentClassName]: parentClassName,
    }

    return (
      <div className={classNames(classes)}>
        {
          this.props.onClick
          ?
          <Link parentClassName="pb-stat__link" onClick={this.props.onClick}>{iconEl}{stateEl}{labelEl}</Link>
          :
          <span dir={this.props.isRtl ? 'rtl' : 'ltr'}>{iconEl}{stateEl}{labelEl}</span>
        }
      </div>
    );
  }
}

Stat.propTypes = {
  parentClassName: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  iconVariant: SvgIcon.propTypes.variant,
  size: PropTypes.oneOf([
    's',
    'm',
    'l'
  ]),
  align: PropTypes.oneOf([
    'left',
    'center'
  ]),
  section: PropTypes.string
};

export default translate()(Stat);



// WEBPACK FOOTER //
// ./src/components/Stat/Stat.jsx